module.exports = __webpack_public_path__ + "static/media/avatar.07ecffa8.png";